import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconPhone: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 3c0-.6.4-1 1-1 4.6 0 8 3.4 8 8 0 .6-.4 1-1 1s-1-.4-1-1c0-3.4-2.6-6-6-6-.6 0-1-.4-1-1Zm5.9 12.3-4.1-1.7c-.4-.2-.8-.1-1.1.2l-.9.9c-.7-.5-1.3-1.1-2-1.8s-1.3-1.4-1.8-2l1-.8c.3-.3.4-.7.2-1.1L8.6 4.9c-.1-.3-.3-.5-.5-.6C7.5 4.1 7 4 6.4 4 4 4 2 6 2 8.4c0 3.1 1.5 6.1 4.4 9.1 2.9 3 6 4.5 9 4.5 2.4 0 4.4-2 4.4-4.4 0-.6-.1-1.1-.3-1.7-.2-.3-.4-.5-.6-.6ZM15.4 20c-2.5 0-5-1.3-7.6-3.9C5.3 13.5 4 10.9 4 8.4 4 7.1 5.1 6 6.4 6c.2 0 .4 0 .5.1l1.2 3.1-1 1.1c-.3.2-.4.8-.1 1.1.7 1 1.5 2 2.5 3s2 1.8 3 2.5c.4.3.9.2 1.3-.1l1-1 3 1.2c0 .1.025.2.05.3.025.1.05.2.05.3-.1 1.3-1.2 2.4-2.5 2.4ZM13 8c1.7 0 3 1.3 3 3 0 .6.4 1 1 1s1-.4 1-1c0-2.9-2.1-5-5-5-.6 0-1 .4-1 1s.4 1 1 1Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
